angular
	.module 'App.Module.ShippingMethod', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'shipping_method',
				url: '/shipping-methods',
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'

					'entity_search@shipping_method':
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'BaseSearchController'
						controllerAs: 'search'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					providers: (ShippingMethodDataProviderRepository) ->
						return ShippingMethodDataProviderRepository.getEntities()
					priceRegions: (PriceRegionRepository) ->
						return PriceRegionRepository.getEntities()
					vatRates: (VatRateRepository) ->
						return VatRateRepository.getEntities()
				data:
					restrict: 'Backoffice.TopMenu.Inventory.ShippingMethod.Enabled'
					searchParams:
						repositoryName: 'ShippingMethodRepository'
						title: 'general.shipping_methods'

			.state 'shipping_method.edit',
					url: '/:id'
					views:
						entity_view:
							templateUrl: '@app/layout/views/app.entity-container.view.html'
					resolvePolicy: DEFAULT_RESOLVE_POLICY
					resolve:
						shippingMethod: (ShippingMethodRepository, $stateParams) ->
							return ShippingMethodRepository.getEntity $stateParams.id

			.state 'shipping_method.edit.details',
					url: '/edit',
					views:
						entity_sub_view:
							controller: 'ShippingMethodController'
							controllerAs: 'vm'
							templateUrl: '@app/shipping-method/shipping-method.view.html'
